import { Vue } from 'vue-property-decorator';
import moment from 'moment';
import { GlobalVariables } from '@/libs/core/global';
import { i18n } from '@/i18n';

Vue.filter('formatDate', (value: string) => {
    if (value) {
        const minDate = '1970-01-01';
        if (moment(String(value)).isBefore(minDate)) {
            return null;
        }
        return moment(String(value)).locale(GlobalVariables.lang).format('DD.MM.YYYY HH:mm');
    }
});

Vue.filter('formatSimpleDate', (value: string) => {
    if (value) {
        const minDate = '1970-01-01';
        if (moment(String(value)).isBefore(minDate)) {
            return null;
        }
        return moment(String(value)).locale(GlobalVariables.lang).format('DD.MM.YYYY');
    }
});

Vue.filter('formatDateName', (value: string) => {
    if (value) {
        const minDate = '1970-01-01';
        if (moment(String(value)).isBefore(minDate)) {
            return null;
        }
        return moment(String(value)).locale(GlobalVariables.lang).format('dddd');
    }
});

Vue.filter('formatTime', (value: string) => {
    if (value) {
        const minDate = '1970-01-01';
        if (moment(String(value)).isBefore(minDate)) {
            return null;
        }
        return moment(String(value)).locale(GlobalVariables.lang).format('HH:mm');
    }
});

Vue.filter('subtract', (value: string, amount: number, unit: string) => {
    if (value) {
        return moment(String(value))
            .subtract(amount as any, unit as any)
            .toDate();
    }
});

Vue.filter('formatDateCustom', (value: string, formatString: string) => {
    if (value) {
        return moment(String(value)).locale(GlobalVariables.lang).format(formatString);
    }
});
